<template>
    <section class="section sub-visual-office">
        <v-container>
            <v-row class="line-height-1" align="end">
                <v-col cols="auto">
                    <h2 class="font-size-32 font-size-md-46 font-size-lg-56 font-weight-bold">{{sh}}</h2>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto" class="d-flex align-center font-size-12 font-size-lg-14 color-grey-7">
                    <p>기업소개</p>
                    <i class="icon icon-right-arrow-sm mx-6 mx-lg-16"></i>
                    <p class="font-weight-bold color-black">{{sh}}</p>
                </v-col>
            </v-row>
            <div class="sub-visual-office--bg mt-50 mt-lg-80" :style="'background-image:url('+ bg +');'"></div>
            <div class="sub-visual-office--detail mt-30 mt-lg-54">
                <slot/>
            </div>
        </v-container>
        <router-link class="link-box mt-30 mt-lg-0" :to="link">
            <div class="w-100 w-lg-260px h-lg-260px py-20 py-md-30 py-lg-34 px-12 px-lg-32 color-white d-flex flex-column align-center align-lg-start justify-space-between text-center text-lg-left">
                <h6 class="font-size-18 font-size-lg-22 font-weight-bold">
                    세일즈웍스의 <br class="d-none d-lg-block">
                    {{linkText}}
                </h6>
                <div class="d-flex align-center mt-6 mt-lg-0">
                    <p class="font-size-14 font-size-lg-18 line-height-1">
                        {{shRe}}안내
                    </p>
                    <i class="icon icon-right-arrow-w ml-6 ml-lg-16"></i>
                </div>
            </div>
        </router-link>
    </section>
</template>

<script>

export default{
    props : {
        sh : {type :String, default : ""},
        shRe : {type :String, default : ""},
        bg : {type :String, default : ""},
        link : {type :String, default : ""},
        linkText : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
.sub-visual-office{
    margin-top: var(--header-body);
}

.sub-visual-office--bg{
    width: 100vw;
    height: 100px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    background-position: 10% center;
    background-repeat: no-repeat;
    background-size: cover;
}
.sub-visual-office--detail p{
    font-size: 1.6rem;
    line-height: 22px;
}
.sub-visual-office--detail p:not(:last-child){
    margin-bottom: 8px;
}
.link-box {
    display: block;
    background-color: var(--v-primary-base);
    transition: 0.15s ease-out;
}
@media (min-width:576px){
}
@media (min-width:768px){
    .sub-visual-office--bg{
        height: 280px;
    }
}
@media (min-width:1024px){
    .link-box {
        position: absolute;
        top: 290px;
        right: 0;
        background-color: #222;
        transform: translateX(50%);
        opacity: 0;
        animation: fadeLeft 0.5s ease-out forwards;
    }
    @keyframes fadeLeft {
        0%{
            transform: translateX(50%);
            opacity: 0;
        }
        100%{
            transform: translateX(0);
            opacity: 1;
        }
    }
    .link-box:hover{
        background-color: var(--v-primary-base);
    }
    .sub-visual-office--detail p{
        font-size: 2.4rem;
        line-height: 36px;
    }
    .sub-visual-office--detail p:not(:last-child){
        margin-bottom: 24px;
    }
    .sub-visual-office--bg{
        height: 360px;
    }
}
@media (min-width:1200px){
    .link-box {
        top: 345px;
    }
}
@media (min-width:1760px){
    .link-box {
        top: 200px;
    }
}

</style>